import { createFileRoute } from '@tanstack/react-router'
import { useCallback } from 'react'

import { QaPlayer, type QaPlayerSearch } from '@/components/qa/qa-player'
import { isQaFilter } from '@/lib/qa-player'

/** `?cas=&etape=` (ou `?fin=1`) garde la position ; `?filtre=` reprend celui de la page. */
function readPlayerSearch(search: Record<string, unknown>): QaPlayerSearch {
  return {
    filtre: isQaFilter(search.filtre) ? search.filtre : 'tous',
    ...(typeof search.cas === 'string' && search.cas ? { cas: search.cas } : {}),
    ...(typeof search.etape === 'string' && search.etape ? { etape: search.etape } : {}),
    ...(search.fin === true || search.fin === 'true' || search.fin === 1 || search.fin === '1'
      ? { fin: true }
      : {}),
  }
}

export const Route = createFileRoute('/_app/qa/$runId_/jouer')({
  validateSearch: readPlayerSearch,
  component: QaPlayerRoute,
})

function QaPlayerRoute() {
  const { runId } = Route.useParams()
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const onNavigate = useCallback(
    (next: QaPlayerSearch) => {
      // Chaque diapositive remplace la précédente : « Retour » ramène à la campagne.
      void navigate({ search: next, replace: true })
    },
    [navigate],
  )
  const onQuit = useCallback(() => {
    void navigate({ to: '/qa/$runId', params: { runId } })
  }, [navigate, runId])

  return (
    <QaPlayer key={runId} runId={runId} search={search} onNavigate={onNavigate} onQuit={onQuit} />
  )
}
